import type { ReactNode } from "react";
import { PageWrapper } from "@/deps/ui-library";

/**
 * A screen's header: RDS `PageWrapper.Header`, with the actions on the right through its `actions`
 * (ADR-0093) — the title, the muted line under it when the screen needs one, and at most two
 * actions. The frame around the screen (its padding and width) is the shell's `main`.
 */
export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <PageWrapper.Header actions={actions}>
      <PageWrapper.Title>{title}</PageWrapper.Title>
      {subtitle ? <PageWrapper.Description>{subtitle}</PageWrapper.Description> : null}
    </PageWrapper.Header>
  );
}
